import { Box } from "@mui/material";

const NestedCardsWrapper = ({ children }) => {
    return (
        <Box
            sx={{
                // This applies to all descendant Card components
                "& .MuiCard-root": {
                    padding: "10px",
                    marginBottom: "10px",
                    flex: 1,
                },
                // This applies to all descendant CardHeader components
                "& .MuiCardHeader-root": {
                    padding: 0,
                    "& .MuiTypography-root": {
                        fontWeight: "bold",
                        textTransform: "uppercase",
                        fontSize: ".875rem",
                    },
                },
                // This applies to all descendant CardContent components
                "& .MuiCardContent-root": {
                    paddingLeft: 0,
                    paddingRight: 0,
                    paddingBottom: "10px !important",
                },
            }}
        >
            {children}
        </Box>
    );
};

export default NestedCardsWrapper;
